export default {
    toastText: "Copied!",
};
